export default __webpack_public_path__ + "static/media/logotype_white.1eebbb2a.svg";